exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-6-wrapper[data-v-3333aa60]{width:200px;padding-bottom:10px}", ""]);

// exports
